export interface FilterKVP {
  keyID: number;
  keyTitle: string;
  valueID: number;
  valueTitle: string;
}

export const filterKVPFromResponse = (responseData: any): FilterKVP => ({
  keyID: responseData.key_id,
  keyTitle: responseData.key_title,
  valueID: responseData.value_id,
  valueTitle: responseData.value_title,
});
